import OptionsPanel from "./OptionsPanel.js"

export default class BackgroundOpacity extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Background Opacity" // TODO: This needs to be localized
    this.setting = "backgroundOpacity"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
